import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    wrapper: {
        display: "flex",
        gap: "40px",
        maxWidth: "1200px",
        margin: "50px auto",
        padding: "0 20px",
        fontFamily: "'Inter', sans-serif",
    },

    contentBox: {
        flex: 1,
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(6px)",
        borderRadius: "12px",
        padding: "24px",
        color: "#111827",
    },

    toc: {
        width: "220px",
        position: "sticky",
        top: "100px",
        height: "fit-content",
        fontSize: "13px",
        color: "#374151",
    },

    tocItem: {
        marginBottom: "8px",
        cursor: "pointer",
        transition: "all 0.2s",

        "&:hover": {
            color: "#7c3aed",
        },
    },
}));

export default function LegalPage({ title, children }) {
    const classes = useStyles();

    const sections = React.Children.toArray(children).filter(
        (child) => child.type === "h2"
    );

    const handleScroll = (index) => {
        const el = document.getElementById(`section-${index}`);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <div className={classes.wrapper}>
            {/* MAIN CONTENT */}
            <div className={classes.contentBox}>
                <h1>{title}</h1>

                {React.Children.map(children, (child, index) => {
                    if (child.type === "h2") {
                        return React.cloneElement(child, {
                            id: `section-${index}`,
                        });
                    }
                    return child;
                })}
            </div>

            {/* TOC */}
            <div className={classes.toc}>
                <strong>Inhalt</strong>
                <div style={{ marginTop: "10px" }}>
                    {sections.map((section, index) => (
                        <div
                            key={index}
                            className={classes.tocItem}
                            onClick={() => handleScroll(index)}
                        >
                            {section.props.children}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}